export interface CategoryUI {
  categoryId: number;
  categoryName: string;
  categoryHexColor: string;
  SortOrder: number;
  isCustom: boolean;
  techSpendActive: boolean;
  storefrontActive: boolean;
  subCategories?: CategoryUI[];
  parentCategoryId?: number;
  UsedInStoreFront: boolean;
  UsedInTechSpend: boolean;
  Tooltip: string;
}

export interface CategoryBE {
  Id: number;
  Name: string;
  ColorCode: string;
  SortOrder: number;
  isCustomCategory: boolean;
  TechVisibility: boolean;
  StoreVisibility: boolean;
  SubCatList?: CategoryBE[];
  parentCategoryId?: number;
  UsedInStoreFront: boolean;
  UsedInTechSpend: boolean;
  Tooltip: string;
}

export const UpdateTaxRateState = {
  None: 0,
  Default: 1,
  Active: 2,
};

export enum CategoryProductType {
  TechSpend = 0,
  Storefront = 1,
}

export enum CategoryResetType {
  Color = 0,
  Sort = 1,
  Visibility = 2,
  All = 3,
}

export const CategoryResetTypeList = [
  {
    label: 'Color',
    value: CategoryResetType.Color,
    message: 'Are you sure you want to reset the color of categoeries?'
  },
  {
    label: 'Sort',
    value: CategoryResetType.Sort,
    message: 'Are you sure you want to reset the sort of categories?'
  },
  {
    label: 'Visibility',
    value: CategoryResetType.Visibility,
    message: 'Are you sure you want to reset the visibility of categories?'
  },
  {
    label: 'All',
    value: CategoryResetType.All,
    message: 'Are you sure you want to reset the color, sort, and visibility of categories?'
  },
]

export const CategoriesColorSequence = [
  '#88F574', '#FA8072', '#0047AB', '#E75480', '#53797B', '#F55FC2', '#53797B', '#944378', '#7622E3', '#09C4EF',
  '#E1AD01', '#5E47FA', '#3AEEC3', '#007FFF', '#82212B', '#18749C', '#EFFF85', '#FA6813', '#708D23', '#A67DF5',
  '#498328', '#DA70D6', '#42E25A', '#453551', '#F4E856', '#35494B', '#E0B0FF', '#C7142A', '#A8553C', '#6A0DAD'
]
